import React, { useState } from "react";

const Registration = () => {
	 const [step, setStep] = useState(1);
	  const [formData, setFormData] = useState({
		name: "",
		confirmName: "",
		payment: "",
	  });
	
	  const nextStep = () => {
		// Simple validation example
		// if (step === 1 && !formData.name) {
		//   alert("Please enter traveller name");
		//   return;
		// }
		// if (step === 2 && !formData.confirmName) {
		//   alert("Please confirm booking name");
		//   return;
		// }
		setStep((prev) => prev + 1);
	  };
	
	  const prevStep = () => setStep((prev) => prev - 1);
	
	  const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	  };
	return(
  <> 
 <div id="kt_body" class="auth-bg">
	<div class="d-flex flex-column flex-root">			
			<div class="d-flex flex-column flex-column-fluid flex-lg-row">
		
				<div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
				
					<div class="d-flex flex-center flex-lg-start flex-column">
			
						<a href="/" class="mb-7">
							<img src="/assets/images/logo.png" alt="img" className='logo_login' />
						</a>
						<h2 class="text-white fw-normal m-0">Branding tools designed for your business</h2>
			
					</div>
				</div>
        <div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
			
					<div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-500px p-10">
		
						<div class="d-flex flex-start flex-column flex-column-fluid px-lg-0">
									{/* <h1 class="text-gray-900 fw-bolder mb-3">Welcome to Board</h1> */}
							
      

      {/* Step 1 */}
      {step === 1 && (
        <div>
          <div className="col-md-12 col-lg-12">
            <h4 className="sub_headings">Verify Your Mobile Number</h4>
			<div class="row">
			<div class="col-md-12">
				<div class="form-group">
					<label class="required">Mobile Number</label>
					<input class="form-control form-control-solid" placeholder="." id="" type="text" defaultValue="" name="" />
				</div>
			</div>
			<div class="col-md-8 col-6">
				<div class="form-group">
					<label class="required">Enter OTP</label>
					<input class="form-control form-control-solid" placeholder="." id="" type="text" defaultValue="" name="" />
				</div>
			</div>
			<div class="col-md-4 mt-10 col-6">
				<a href="" className="resend">Resend OTP</a>
			</div>
			</div>
            </div>
          <div className="button-list">              
		  <p class="Already">Already have an account? <a href="/login"> Sign in</a></p>
          <button className="btn btn-primary" onClick={nextStep}>
            Verify
          </button>
        </div>
        </div>
      )}

      {/* Step 2 */}
      {step === 2 && (
        <div>
          <div className="col-md-12 col-lg-12">
            <h4 className="sub_headings">Verify Email Address</h4>
             
			<div class="row">
			<div class="col-md-12">
				<div class="form-group">
					<label class="required">Email Address</label>
					<input class="form-control form-control-solid" placeholder="." id="" type="text" defaultValue="" name="" />
				</div>
			</div>
			<div class="col-md-8 col-6">
				<div class="form-group">
					<label class="required">Enter OTP</label>
					<input class="form-control form-control-solid" placeholder="." id="" type="text" defaultValue="" name="" />
				</div>
			</div>
			<div class="col-md-4 mt-10 col-6">
				<a href="" className="resend">Resend OTP</a>
			</div>
			</div>
            </div>
            

          <div className="button-list">
          <button className="btn-btn-border" onClick={prevStep}>
            Back
          </button>
          <button className="btn btn-primary" onClick={nextStep}>
            Verify
          </button>
        </div>
        </div>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <div>
          <div className="col-md-12 col-lg-12">
            <h4 className="sub_headings">Details</h4>
            <div className="row">
				<div class="col-md-6">
						<div class="form-group">
							<label class="">First Name</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label class="">Last Name</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label class="">Gender</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">Select Gender</option>
								<option value="1">Male</option>
								<option value="2">Female</option>
								<option value="3">Others</option>
							</select>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label class="">GST Number</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					
					
					

			</div>
                </div>
<div class="form-check form-check-custom form-check-solid mb-2 mt-2"><input class="form-check-input" id="NonStop" type="checkbox" value="" /><label class="form-check-label" for="NonStop">Non Stop Flights Only</label></div>
        <div className="button-list">
          <button className="btn-btn-border" onClick={prevStep}>
            Back
          </button>
		  <a href="" className="btn btn-primary">Submit  & Update Details</a>
          
        </div>
        </div>
      )}

           
							
						</div>
						
					</div>
				</div>
				
			</div>
		</div>
		</div>

  </>
   
)};

export default Registration;
